import { BrandMenu } from '@prismamedia/one-components';
import React, { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useGetBrandKey } from '../../apollo/sharedQueries/getBrandKeys.web.graphql';

export const BrandSwitch: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  const switchBrand = (brandKey: string) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set('brand', brandKey);
    const newLocation = {
      ...location,
      search: newParams.toString(),
    };
    history.push(newLocation);
  };

  const { data: brandKeys } = useGetBrandKey();

  let defaultValue = '';
  if (brandKeys?.categories?.length === 1) {
    defaultValue = brandKeys.categories[0].brandKey;
  }

  if (!searchParams.get('brand') && defaultValue) {
    switchBrand(defaultValue);
  }

  const currentBrand = searchParams.get('brand') || defaultValue;
  if (!brandKeys) {
    return <></>;
  }
  return (
    <BrandMenu
      items={brandKeys.categories.map(({ id, brandKey }) => ({
        id,
        label: brandKey,
        selected: brandKey === currentBrand,
      }))}
      onItemSelect={({ label }) => switchBrand(label as string)}
    />
  );
};
